/**
 * Used for GetHospitalSchedule to indicate what range of schedules are being request from the specified date.
 */
export enum HospitalScheduleDateRangeType {
  Year = 0,
  Month = 1,
  Week = 2,
  Day = 3,
}
